import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from "jquery";
import axios from 'axios';
// import 'leaflet.pm'
// import 'leaflet.pm/dist/leaflet.pm.css'
import 'leaflet/dist/leaflet.css'
Vue.config.productionTip = false

Vue.prototype.$axios = axios 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
